module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.faults && _vm.faults.length > 0) ? _c('v-container', {
    staticClass: "Faults pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "ListHeader my-3 px-4",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "subheading mx-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("FaultsDetailsList.date")))]), _vm._v(" "), _c('v-flex', {
    staticClass: "subheading mx-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("FaultsDetailsList.code")))]), _vm._v(" "), _c('v-flex', {
    staticClass: "subheading mx-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("FaultsDetailsList.duration")))]), _vm._v(" "), _c('v-flex', {
    staticClass: "subheading mx-1",
    attrs: {
      "xs4": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("FaultsDetailsList.timeToGetBack")))]), _vm._v(" "), _c('v-flex', {
    staticClass: "subheading mx-1",
    attrs: {
      "xs7": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("FaultsDetailsList.detail")))])], 1), _vm._v(" "), _vm._l((_vm.faultsItems), function(item) {
    return _c('v-layout', {
      key: _vm.title + _vm.locationName + '_fault' + item.id,
      staticClass: "ListItem px-4 py-2",
      class: {
        Active: (_vm.selectedFault && _vm.selectedFault.id === item.id)
      },
      attrs: {
        "row": ""
      },
      on: {
        "click": function($event) {
          return _vm.selectFault(item)
        }
      }
    }, [_c('v-flex', {
      staticClass: "subheading ma-1",
      attrs: {
        "xs2": ""
      }
    }, [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('v-flex', {
      staticClass: "subheading ma-1",
      attrs: {
        "xs2": ""
      }
    }, [_vm._v(_vm._s(item.code))]), _vm._v(" "), _c('v-flex', {
      staticClass: "subheading ma-1",
      attrs: {
        "xs2": ""
      }
    }, [_vm._v(_vm._s(item.duration))]), _vm._v(" "), _c('v-flex', {
      staticClass: "subheading ma-1",
      attrs: {
        "xs4": ""
      }
    }, [_vm._v(_vm._s(item.recover_time))]), _vm._v(" "), _c('v-flex', {
      staticClass: "subheading ma-1",
      attrs: {
        "xs7": ""
      }
    }, [_vm._v(_vm._s(item.details))])], 1)
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-690dd231","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/CircularGraphicsComponents/FaultsDetailsList.vue
// module id = 1723
// module chunks = 0